import type { AuthPayload } from "./../../models/auth.model";
import { ValidationError } from "@trading/infrastructure/src/api/errorTypes";
import type { AuthRepository } from '../../repositories/auth/auth.repository';
import type LoginDTO from '../../repositories/auth/dto/login.dto';
import type RegisterDTO from '../../repositories/auth/dto/register.dto';
import { isApiError, isMultipleValidationError } from '@trading/infrastructure/src/api/types'
import type { ApiResponse } from '@trading/infrastructure/src/api/types'
import type SsoDTO from "../../repositories/auth/dto/sso.dto";

export default class AuthController {
  constructor(
    private authRepository: AuthRepository,
  ) {
  }

  async loginRequest(dto: LoginDTO): Promise<ApiResponse<AuthPayload>> {
    try {
      return await this.authRepository.login(dto)
    } catch (error) {
      if (isMultipleValidationError(error)) {
        throw new ValidationError('Login Validation failed', error.error)
      }
      throw error
    }
  }

  async loginRequestByAccount(dto: LoginDTO): Promise<ApiResponse<AuthPayload>> {
    try {
      return await this.authRepository.loginByAccount(dto)
    } catch (error) {
      if (isMultipleValidationError(error)) {
        throw new ValidationError('Login Validation failed', error.error)
      }
      throw error
    }
  }

  async loginRequestBySso(dto: SsoDTO): Promise<ApiResponse<AuthPayload>> {
    try {
      return await this.authRepository.loginBySso(dto)
    } catch (error) {
      if (isMultipleValidationError(error)) {
        throw new ValidationError('Login Validation failed', error.error)
      }
      throw error
    }
  }

  async logoutRequest(): Promise<ApiResponse<void>> {
    try {
      return await this.authRepository.logout()
    } catch (error: unknown) {
      throw error
    }
  }

  async registerRequest(dto: RegisterDTO): Promise<ApiResponse<AuthPayload>> {
    try {
      return await this.authRepository.register(dto)
    } catch (error: unknown) {
      if (isApiError(error)) {
        throw new Error(error.message)
      }
      throw new Error('что то пошло не так')
    }
  }

  async refreshRequest() {
    try {
      return await this.authRepository.refresh()
    } catch (error: unknown) {
      if (isApiError(error)) {
        throw new Error(error.message)
      }
      throw new Error('что то пошло не так')
    }
  }


  // async subscribeToOrdersChannel(
  //   actionName: ChanelActionType,
  //   cb: (order: IncomingMessagePayload<OrderWSUpdate>) => void
  // ): Promise<undefined | CallableFunction> {
  //   if (!this.orderRepositoryWs || typeof this.orderRepositoryWs.subscribeToChannelsAction !== 'function') return
  //   return await this.orderRepositoryWs.subscribeToChannelsAction(actionName, cb)
  // }
}
